import React, { Component } from 'react'

export type LabelType = 'success' | 'warning' | 'danger' | 'light' | 'dark' | 'gray'
type LabelSize = 'regular' | 'large'
type LabelTypeClassName = Record<LabelType, string>
type LabelSizeClassName = Record<LabelSize, string>

export interface LabelProps {
  type: LabelType
  text: string
  size: LabelSize
  rounded?: boolean
  className?: string
}

export default class Label extends Component<LabelProps> {
  labelTypes: LabelTypeClassName = {
    success: 'bg-green-500 text-white',
    warning: 'bg-yellow-500 text-white',
    danger: 'bg-red-500 text-white',
    light: 'bg-yellow-200 text-gray-700',
    dark: 'bg-gray-800 text-white',
    gray: 'bg-gray-300 text-white'
  }

  labelSizes: LabelSizeClassName = {
    regular: 'px-2 leading-4 text-xxs',
    large: 'px-5 leading-6 text-xs'
  }

  get className () {
    const base = 'inline-block h-fit'
    const type = this.labelTypes[this.props.type]
    const size = this.labelSizes[this.props.size]
    const rounded = this.props.rounded ? 'rounded' : ''
    return `${base} ${type} ${size} ${rounded} ${this.props.className}`
  }

  render () {
    return (
      <div className={this.className}>
        {this.props.text}
      </div>
    )
  }
}
